import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {ID} from "../../../core/metamodel/metaConstant";
import {Area} from "./areaDomain";

@entityConfig()
export class ProjectVersionArea extends DomainAncestor {

  @observable areaId : number;
  @observable projectVersion : LovItem;
  @observable area : Area;
  @observable m2 : number;
  @observable note : string;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.areaId;
  }

  public setId(id: ID): void {
    this.areaId = <number>id;
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionAreaDomain.ts